export const siteSettings = {
  name: "Caps Xchange",
  link: "https://capsxchange.org",
  email: "support@capsxchange.org",
  appLink: "https://app.capsxchange.org",
};
